export var radii = {
  none: 0,
  s: '2px',
  m: '4px',
  l: '8px',
  xl: '16px',
  xxl: '24px',
  full: '9999px'
};
//# sourceMappingURL=radii.js.map